import React from "react";
import { Text } from "react-native-paper";
import { StyleSheet, View, Image, Dimensions } from "react-native";
import { whiteColor, blackColor, greenBold } from "./../../common/colors";
import arrowLeft from "../Images/arrowLeft.png";
import arrowRight from "../Images/arrowRight.png";
import CircleSlider from "../../common/CircleSlider";

const Question = ({ question, sliderValue, onSliderValue, button }) => {
  return (
    <>
      <Text style={styles.questionTitle}>{question.question}</Text>
      <View style={styles.slideContainer}>
        <CircleSlider sliderValue={sliderValue} onValueChange={onSliderValue} />
      </View>
      <View style={styles.questionContent}>
        <Image source={arrowLeft} />
        <View style={styles.breakLine}>
          <Image source={arrowRight} />
        </View>
      </View>
      <View style={styles.questionContent}>
        <Text style={styles.questionLeft}>{question.answers[0]}</Text>
        <Text style={styles.questionRight}>{question.answers[1]}</Text>
      </View>
      {button()}
    </>
  );
};
export default Question;

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 30,
    width: "100%",
    backgroundColor: whiteColor,
  },
  slideContainer: {
    paddingBottom: 16,
    width: Dimensions.get("window").width >= 390 ? "100%" : 300,
  },
  slider: {
    width: 308,
    height: 8,
    backgroundColor: "#E8E8E8",
  },
  questionTitle: {
    fontSize: 16,
    lineHeight: 24.5,
    textAlign: "center",
    paddingBottom: 50,
    padding: 20,
    height: 120,
  },
  questionContent: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    alignContent: "center",
  },
  questionLeft: {
    textAlign: "center",
    paddingRight: 30,
    width: Dimensions.get("window").width >= 390 ? 190 : 150,
    fontSize: 16,
    lineHeight: 20,
    height: 100,
  },
  questionRight: {
    width: Dimensions.get("window").width >= 390 ? 190 : 150,
    textAlign: "center",
    paddingLeft: 30,
    fontSize: 16,
    lineHeight: 20,
    height: 100,
  },
  breakLine: {
    paddingLeft: 130,
  },
  messagecontainer: {
    backgroundColor: whiteColor,
    width: "100%",
    height: "100%",
    alignItems: "center",
    display: "flex",
  },
  back: {
    paddingRight: 100,
    alignItems: "flex-end",
    display: "flex",
  },
  close: {
    paddingLeft: 200,
    paddingRight: 100,
  },
  icons: {
    textAlign: "center",
    paddingLeft: 100,
    paddingBottom: 24,
    display: "flex",
    flexDirection: "row",
  },
  container: {
    padding: 24,
    backgroundColor: whiteColor,
    width: "100%",
    alignItems: "center",
    paddingTop: 20,
  },
  title: {
    textAlign: "left",
    fontSize: 24,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 24,
    paddingTop: 24,
    textTransform: "uppercase",
    marginRight: 185,
  },
  headermessage: {
    textAlign: "left",
    fontSize: 14,
    padding: 6,
    lineHeight: 18.75,
    letterSpacing: 1.25,
    paddingRight: 48,
    paddingLeft: 0,
    paddingTop: 24,
    paddingBottom: 24,
  },
  manywords: {
    alignItems: "stretch",
  },
  headertwomessage: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 20,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 24,
  },
  headerthreemessage: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 20,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 24,
  },
  textButton: {
    color: blackColor,
  },
  divider: {
    height: 10,
    backgroundColor: whiteColor,
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    paddingTop: 50,
    paddingLeft: 24,
    paddingRight: 24,
  },
  button: {
    borderWidth: 1,
    width: "100%",
    borderColor: blackColor,
  },
  greenbold: {
    color: greenBold,
    fontWeight: "700",
  },
});
